/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
import $ from 'jquery';
import { each, isNil } from 'lodash';
import moment from 'moment';
import axios from 'axios';
import { x } from '../_helpers';
import {
  liveMatchVoc,
  hiddenClassName,
  winClassName,
  matchCardLiveClassName,
  homePlayerStatus,
  awayPlayerStatus,
  tournamentScoresAdValue,
  matchCardLiveHook,
  matchCardLiveStartTimeAttr,
  matchCardMatchStatusAttr,
  matchCardLiveStatus,
  matchCardLiveUpdateApiBasePath,
  matchCardLiveUpdatePollingTime,
  matchCardLiveUpdateCountDown,
  minToMillisConvertSeed,
  secsToMillisConvertSeed,
  matchCardMatchIdAttr,
  dataLoadStartEvent,
  localTimeHook,
  matchCardDetailStatusHook,
  matchCardDetailScoreHook,
  matchCardDetailScoreContainerHook,
  matchCardDetailHomePlayerHook,
  matchCardDetailAwayPlayerHook,
  matchCardDetailPlayerServiceIconHook,
  matchCardDetailPlayerServiceTextHook,
  matchCardDetailPredictionsHook,
  matchCardNotStartedStatus,
  matchCardAboutToStartStatus,
  matchCardDelayedStatus,
  matchCardPostPonedStatus,
  matchCardDetailPlayerWinnerIconHook,
  matchCardDetailPlayerWinnerTextHook,
  matchCardInterruptedStatus,
  matchCardDetailStartTimeHook,
  TennisChannelVideoButtonHook,
  TennisChannelVideoPlusButtonHook,
  MatchReplayVideoButtonHook,
  matchCardDetailButtonsHook,
} from '../_helpers/constants';

import LocalTime from './local-time';

export default class MatchLiveUpdate {
  constructor() {
    window.liveMatchesData = window.liveMatchesData || {};

    this.items = x(matchCardLiveHook);
    this.element = null;
    this.firstChild = null;
    this.$element = null;
    this.startTime = null;
    this.matchSlug = null;
    this.matchId = null;
    this.tournamentId = null;
    this.interval = null;
    this.url = null;
    this.isDetail = false;
    this.isDrawsPage = false;
    this.localTime = new LocalTime();

    this.countDownTime = matchCardLiveUpdateCountDown * minToMillisConvertSeed;
    this.liveUpcomingMatches = [];
    this.remainingLiveUpcomingMatches = [];
    this.lowestCountDownTime = 0;
    this.existLiveMatch = false;
    this.liveMatchesUrl = matchCardLiveUpdateApiBasePath;
    this.cardMatchClass = '.tc-match';    
  }

  initPolling() {
    const firstMatchWrapper = this.items[0];
    this.isDrawsPage = firstMatchWrapper.classList.contains('tc-tournament-draw__match');

    const firstChild = $(firstMatchWrapper).find('.tc-match-details__match-card')[0];
    if (firstChild) {
      this.isDetail = true;
      this.cardMatchClass = '.tc-match-details__match-card';
    }

    this.setLiveUpcomingMatches();
    if (this.liveUpcomingMatches.length > 0) {
      this.setLiveMatchesAndCountDownTime();

      if (this.existLiveMatch || this.lowestCountDownTime < 0) {
        this.liveMatchesCall(null);
        this.startPolling();
      } else {
        this.startCountDown();
      }
    }
  }

  initItems() {
    this.items = x(matchCardLiveHook);
    this.init();
  }

  startCountDown() {
    setTimeout(() => {
      this.startPolling();
    }, this.lowestCountDownTime);
  }

  startPolling() {
    const pollingTime = matchCardLiveUpdatePollingTime * secsToMillisConvertSeed;
    const _self = this;
    const interval = setInterval(() => {
      _self.liveMatchesCall(interval);
    }, pollingTime);
  }

  liveMatchesCall(interval) {
    const _self = this;
    axios
      .get(`${this.liveMatchesUrl}?v=${Math.random()}`)
      .then((resp) => {
        window.liveMatchesData = resp.data;
        _self.updateCards(resp.data, interval);
      })
      .catch(() => {
        if (interval) {
          window.clearInterval(interval);
        }
      });
  }

  updateCards(liveData, interval) {
    if (!liveData) {
      return;
    }

    const now = moment();
    this.liveUpcomingMatches.forEach((matchWrapper) => {
      const match = matchWrapper.querySelector(this.cardMatchClass);
      const matchSlug = match.dataset.matchSlug.replaceAll('-', ':');

      const newMatchData = liveData.find((newMatch) => newMatch.MatchId === matchSlug);

      if (newMatchData) {
        const startTime = moment(newMatchData.StartTimeUtc);
        const timeDiff = startTime.diff(now) - this.countDownTime;
        if (timeDiff < 0) {
          this.updateMatchCard(match, newMatchData);
        }
      }
    });

    // stop polling if no more live/upcoming events
    if (this.remainingLiveUpcomingMatches.length === 0) {
      window.clearInterval(interval);
    }

    this.toLocalTime();
  }

  updateMatchCard(element, json) {
    // Status
    const status = this.getStatusElement(json.MatchStatus);
    const statusValue = json.MatchStatus;
    const isLiveMatch = this.isLiveMatch(statusValue);

    // Score
    let score = null;
    let homePlayerScore = null;
    let awayPlayerScore = null;
    if (json.MatchScore) {
      if (!this.isDetail) {
        homePlayerScore = this.getPlayerScore(json, homePlayerStatus);
        awayPlayerScore = this.getPlayerScore(json, awayPlayerStatus);
      } else {
        score = this.getMatchDetailsScore(json, statusValue);
      }
    }

    //switch live class from match card
    if (!this.isDetail) {
      if (isLiveMatch) {
        this.addClass(element, null, matchCardLiveClassName);
      } else {
        $(element).removeClass(matchCardLiveClassName);
      }
    }

    this.adjustCardElements(json, element, statusValue, isLiveMatch);

    // Status
    if (!this.isDetail) {
      $(element).find(matchCardDetailStatusHook).replaceWith(status);
    } else {
      $(this.items[0]).find(matchCardDetailStatusHook).replaceWith(status);
    }

    // update score elements
    if (json.MatchScore) {
      if (!this.isDetail) {
        this.addSetPlayerScore(
          homePlayerScore,
          element,
          matchCardDetailHomePlayerHook,
          matchCardDetailScoreHook
        );

        this.addSetPlayerScore(
          awayPlayerScore,
          element,
          matchCardDetailAwayPlayerHook,
          matchCardDetailScoreHook
        );
      } else {
        $(element).find(matchCardDetailScoreHook).html(score);

        // set match status info
        this.setDetailMatchStatusIcons(
          json,
          element.querySelectorAll(matchCardDetailHomePlayerHook)[0],
          true,
          isLiveMatch
        );
        this.setDetailMatchStatusIcons(
          json,
          element.querySelectorAll(matchCardDetailAwayPlayerHook)[0],
          false,
          isLiveMatch
        );
      }
    }

    //remove match from live/upcoming matches
    this.removeCheckPollingMatch(json, statusValue);
  }

  removeCheckPollingMatch(json, statusValue) {
    const liveMatch = this.isLiveMatch(statusValue);
    const upcomingMatch = this.getPreMatchStatus(statusValue.toLowerCase());

    if (!liveMatch && !upcomingMatch && this.remainingLiveUpcomingMatches.length > 0) {
      const matchIndex = this.remainingLiveUpcomingMatches.findIndex((matchWrapper) => {
        const match = matchWrapper.querySelector(this.cardMatchClass);
        const matchId = match.dataset.matchSlug.replaceAll('-', ':');
        return matchId === json.MatchId;
      });
      if (matchIndex > -1) {
        this.remainingLiveUpcomingMatches.splice(matchIndex, 1);
      }
    }
  }

  adjustCardElements(json, element, statusValue, isLiveMatch) {
    if (this.isDetail) {
      element = element.parentElement;
    }

    if (statusValue) {
      if (isLiveMatch || this.getPreMatchStatus(statusValue.toLowerCase())) {
        //show live or pre match buttons
        $(element).find(TennisChannelVideoButtonHook).removeClass(hiddenClassName);
        $(element).find(TennisChannelVideoPlusButtonHook).removeClass(hiddenClassName);
        this.addClass(element, MatchReplayVideoButtonHook, hiddenClassName);
      } else {
        //show post match buttons
        $(element).find(MatchReplayVideoButtonHook).removeClass(hiddenClassName);
        this.addClass(element, TennisChannelVideoButtonHook, hiddenClassName);
        this.addClass(element, TennisChannelVideoPlusButtonHook, hiddenClassName);
      }

      //remove elements on status change from prematch
      if (!this.getPreMatchStatus(statusValue.toLowerCase())) {
        this.removeElsOnPrematchChange(element);
      }

      //update estimation time
      if (this.getPreMatchStatus(statusValue.toLowerCase())) {
        const estimationEl = element.querySelector(matchCardDetailStartTimeHook);
        if (estimationEl) {
          this.updateTimeEstimation(json, element);
        }
      }
    }
  }

  removeElsOnPrematchChange(element) {
    //remove prediction element
    const predictionEl = $(element).find(matchCardDetailPredictionsHook)[0];
    if (predictionEl) {
      predictionEl.parentElement.removeChild(predictionEl);
    }

    //remove start time element
    const startTimeEl = $(element).find(matchCardDetailStartTimeHook)[0];
    if (startTimeEl) {
      startTimeEl.parentElement.removeChild(startTimeEl);
    }

    //remove details button on draws
    if (this.isDrawsPage) {
      $(element).find(matchCardDetailButtonsHook).hide();
    }
  }

  getMatchDetailsScore(json, status) {
    const parent = this.createHtmlElement('DIV');

    if (json.MatchStatus && !this.getPreMatchStatus(status.toLowerCase())) {
      const homePlayer = this.getPlayerDetailScore(json, homePlayerStatus);
      parent.appendChild(homePlayer);

      const divider = this.getPlayerDetailScoreDivider(json, homePlayerStatus);
      parent.appendChild(divider);

      const awayPlayer = this.getPlayerDetailScore(json, awayPlayerStatus);
      parent.appendChild(awayPlayer);
    } else {
      parent.appendChild(document.createTextNode('\u00A0'));
    }

    return parent.innerHTML;
  }

  addClass(parent, elementAttr, className) {
    let element = $(parent);
    if (elementAttr) {
      element = $(parent).find(elementAttr);
    }

    if (!element.hasClass(className)) {
      element.addClass(className);
    }
  }

  getStatusElement(status) {
    const span = this.createHtmlElement('SPAN', ['tc-match__status']);

    if (this.getLiveStatus(status.toLowerCase())) {
      span.classList.add(matchCardLiveClassName);
    }
    span.setAttribute('js-match-card-status', '');
    span.appendChild(document.createTextNode(liveMatchVoc[status] || status));
    return span;
  }

  updateTimeEstimation(json, element) {
    const timeEls = element.querySelectorAll(localTimeHook);
    timeEls.forEach((el) => {
      el.dataset.utcTime = json.StartTimeUtc;
    });
  }

  getPlayerDetailScoreDivider(json, playerStatus) {
    const isHomePlayer = playerStatus === homePlayerStatus;
    const isLiveMatch = json.MatchStatus && this.isLiveMatch(json.MatchStatus);

    const divider = this.createHtmlElement('DIV', ['tc-match-details__match-card-score__divider']);
    if (isLiveMatch) {
      divider.classList.add(matchCardLiveClassName);
    }

    const totalContainer = this.createHtmlElement('DIV', [
      'match-card-score__stats-total-container',
    ]);
    if (!isHomePlayer) {
      totalContainer.classList.add('-away');
    }

    const totalSet = this.createHtmlElement('DIV', ['match-card-score__stats--set', '-total']);
    totalSet.appendChild(document.createTextNode(':'));

    totalContainer.appendChild(totalSet);
    divider.appendChild(totalContainer);

    //sets container
    const setsContainer = this.createHtmlElement('DIV', ['match-card-score__stats-sets-container']);

    const sets = json.MatchScore.SetsScore;
    if (sets && sets.length > 0) {
      let isLiveSet = false;
      sets.forEach((_set, index) => {
        if (isLiveMatch && index === sets.length - 1) {
          isLiveSet = true;
        }
        const setEl = this.createHtmlElement('DIV', ['match-card-score__stats--set']);
        if (isLiveSet) {
          setEl.classList.add(matchCardLiveClassName);
        }
        setEl.appendChild(document.createTextNode('-'));

        setsContainer.appendChild(setEl);
      });
    }

    divider.appendChild(setsContainer);

    return divider;
  }

  getPlayerActionData(data, playerHook, iconHook, textHook) {
    const icon = $(data).find(playerHook).find(iconHook)[0];
    const text = $(data).find(playerHook).find(textHook).html();
    return {
      icon,
      text,
    };
  }

  setPlayerActionData(element, playerServiceObject, playerWinnerObject, playerHook) {
    let playerObject = playerServiceObject;
    let iconHook = matchCardDetailPlayerServiceIconHook;
    let textHook = matchCardDetailPlayerServiceTextHook;

    if (isNil(playerObject.icon)) {
      playerObject = playerWinnerObject;
      iconHook = matchCardDetailPlayerWinnerIconHook;
      textHook = matchCardDetailPlayerWinnerTextHook;
    }

    $(element).find(playerHook).find(iconHook).replaceWith(playerObject.icon);

    $(element).find(playerHook).find(textHook).html(playerObject.text);
  }

  getPreMatchStatus(status) {
    const formattedStatus = status.replace(/ /g, '').toLowerCase();

    return (
      formattedStatus === matchCardNotStartedStatus ||
      formattedStatus === matchCardAboutToStartStatus ||
      formattedStatus === matchCardDelayedStatus ||
      formattedStatus === matchCardPostPonedStatus
    );
  }

  getLiveStatus(status) {
    const formattedStatus = status.replace(/ /g, '').toLowerCase();

    return (
      formattedStatus === matchCardLiveStatus || formattedStatus === matchCardInterruptedStatus
    );
  }

  getPlayerDetailScore(json, playerStatus) {
    const isHomePlayer = playerStatus === homePlayerStatus;
    const isLiveMatch = json.MatchStatus && this.isLiveMatch(json.MatchStatus);
    const isWinner = this.getWinner(json, isHomePlayer);

    const parent = this.createHtmlElement('DIV', ['tc-match-details__match-card-score__stats']);
    if (isLiveMatch) {
      parent.classList.add(matchCardLiveClassName);
    }

    //set live or total score
    const scoreWrapper = this.createHtmlElement('DIV', ['match-card-score__stats-total-container']);
    if (!isHomePlayer) {
      scoreWrapper.classList.add('-away');
    }
    if (isWinner) {
      scoreWrapper.classList.add(winClassName);
    }

    this.setScoreWrapper(json, scoreWrapper, isLiveMatch, isWinner, isHomePlayer);
    parent.appendChild(scoreWrapper);

    //set player sets
    const playerSets = this.createHtmlElement('DIV', ['match-card-score__stats-sets-container']);
    if (!isHomePlayer) {
      playerSets.classList.add('-away');
    }
    this.setPlayerSets(json, playerSets, isHomePlayer, isLiveMatch, true);

    parent.appendChild(playerSets);

    return parent;
  }

  setScoreWrapper(json, scoreWrapper, isLiveMatch, isWinner, isHomePlayer) {
    if (isLiveMatch) {
      const sets = json.MatchScore.SetsScore;
      if (sets && sets.length > 0) {
        sets.forEach((_set, index) => {
          this.setSingleSetLiveScore(json, sets, scoreWrapper, index, isHomePlayer);
        });
      }
    } else {
      const totalScore = this.createHtmlElement('DIV', ['match-card-score__stats--set', '-total']);
      if (isWinner) {
        totalScore.classList.add(winClassName);
      }

      const totalScoreValue = isHomePlayer ? json.MatchScore.HomeScore : json.MatchScore.AwayScore;
      totalScore.appendChild(document.createTextNode(totalScoreValue));
      scoreWrapper.appendChild(totalScore);
    }
  }

  setSingleSetLiveScore(json, sets, scoreWrapper, index, isHomePlayer) {
    if (index === sets.length - 1) {
      if (json.GameStatus) {
        const lastSet = this.createHtmlElement('DIV', ['match-card-score__stats--set', '-game']);

        const liveScoreDisplay = this.getLiveScoreValue(json, isHomePlayer);
        lastSet.appendChild(document.createTextNode(liveScoreDisplay));

        scoreWrapper.appendChild(lastSet);
      }
    } else {
      const setsEmptyEl = this.createHtmlElement('DIV', [
        'match-card-score__stats--set',
        '-game',
        '-empty',
      ]);
      setsEmptyEl.appendChild(document.createTextNode('\u00A0'));

      scoreWrapper.appendChild(setsEmptyEl);
    }
  }

  getPlayerScore(json, playerStatus) {
    const isHomePlayer = playerStatus === homePlayerStatus;
    const isLiveMatch = json.MatchStatus && this.isLiveMatch(json.MatchStatus);

    // set match sets
    const parent = this.createHtmlElement('DIV', ['tc-match__stats'], ['js-match-card-score']);

    //set player sets
    this.setPlayerSets(json, parent, isHomePlayer, isLiveMatch, false);

    // set game status set
    if (isLiveMatch && json.GameStatus) {
      const liveSpanEl = this.createHtmlElement('SPAN', ['tc-match__stats--set', '-game']);

      const liveScoreDisplay = this.getLiveScoreValue(json, isHomePlayer);
      liveSpanEl.appendChild(document.createTextNode(liveScoreDisplay));

      parent.appendChild(liveSpanEl);
    }

    // set match status info
    this.setMatchStatusIcons(json, parent, isHomePlayer, isLiveMatch);

    return parent;
  }

  getLiveScoreValue(json, isHomePlayer) {
    //check player advantage
    let advantage = false;
    if (json.GameStatus.TieBreak) {
      if (isHomePlayer) {
        advantage = json.GameStatus.Advantage === homePlayerStatus;
      } else {
        advantage = json.GameStatus.Advantage === awayPlayerStatus;
      }
    }

    //get player live score value
    const liveScore = isHomePlayer ? json.GameStatus.HomeScore : json.GameStatus.AwayScore;
    let liveScoreDisplay = isHomePlayer
      ? json.GameStatus.DisplayHomeScore
      : json.GameStatus.DisplayAwayScore;
    if (advantage || liveScore === 50) {
      liveScoreDisplay = tournamentScoresAdValue;
    }

    return liveScoreDisplay;
  }

  getWinner(json, isHomePlayer) {
    let isWinner = false;
    if (json.WinnerId && (json.MatchScore.HomeScore > 0 || json.MatchScore.AwayScore > 0)) {
      isWinner = isHomePlayer
        ? json.MatchScore.HomeScore > json.MatchScore.AwayScore
        : json.MatchScore.HomeScore < json.MatchScore.AwayScore;
    }
    return isWinner;
  }

  setMatchStatusIcons(json, parent, isHomePlayer, isLiveMatch) {
    const matchStatsEl = this.createHtmlElement('DIV', ['tc-match__stats--info']);

    // check is serving or is winner icon
    let isServing = false;
    if (json.GameStatus) {
      isServing = isHomePlayer
        ? json.GameStatus.Serving === homePlayerStatus
        : json.GameStatus.Serving === awayPlayerStatus;
    }
    const isWinner = this.getWinner(json, isHomePlayer);

    if (isLiveMatch && isServing) {
      // serving icon
      const isServingDivEl = this.createHtmlElement(
        'DIV',
        ['tc-icon--service'],
        ['js-match-card-player-service-icon']
      );
      matchStatsEl.appendChild(isServingDivEl);

    } else if (!isLiveMatch && isWinner) {
      // winner icon
      const isWinnerDivEl = this.createHtmlElement(
        'DIV',
        ['tc-icon--winner-icon'],
        ['js-match-card-player-winner-icon']
      );
      matchStatsEl.appendChild(isWinnerDivEl);
    }

    parent.appendChild(matchStatsEl);
  }

  setDetailMatchStatusIcons(json, parent, isHomePlayer, isLiveMatch) {
    let isServing = false;
    if (json.GameStatus) {
      isServing = isHomePlayer
        ? json.GameStatus.Serving === homePlayerStatus
        : json.GameStatus.Serving === awayPlayerStatus;
    }
    const isWinner = this.getWinner(json, isHomePlayer);

    //reset hidden classes
    this.addClass(parent, matchCardDetailPlayerServiceIconHook, hiddenClassName);
    this.addClass(parent, matchCardDetailPlayerServiceTextHook, hiddenClassName);
    this.addClass(parent, matchCardDetailPlayerWinnerIconHook, hiddenClassName);
    this.addClass(parent, matchCardDetailPlayerWinnerTextHook, hiddenClassName);

    if (isLiveMatch && isServing) {
      // show serving icon
      $(parent).find(matchCardDetailPlayerServiceIconHook).removeClass(hiddenClassName);
      $(parent).find(matchCardDetailPlayerServiceTextHook).removeClass(hiddenClassName);
    } else if (!isLiveMatch && isWinner) {
      // show winner icon
      $(parent).find(matchCardDetailPlayerWinnerIconHook).removeClass(hiddenClassName);
      $(parent).find(matchCardDetailPlayerWinnerTextHook).removeClass(hiddenClassName);
    }
  }

  setPlayerSets(json, parent, isHomePlayer, isLiveMatch, isDetail) {
    const sets = json.MatchScore.SetsScore;
    if (sets && sets.length > 0) {
      sets.forEach((set, index) => {
        let setSpan = this.createHtmlElement('SPAN');
        if (isDetail) {
          setSpan = this.createHtmlElement('DIV', ['match-card-score__stats--set']);
        } else {
          setSpan.classList.add('tc-match__stats--set');
        }

        this.setScoreSet(setSpan, sets, set, index, isHomePlayer, isLiveMatch);
        parent.appendChild(setSpan);
      });
    }
  }

  setScoreSet(setSpan, sets, set, index, isHomePlayer, isLiveMatch) {
    let liveClass = '';
    let setResultClass = '';
    let setWinner = false;
    let setScore = 0;
    let tieBreakScore = 0;

    if (isHomePlayer) {
      if (set.HomeScore > set.AwayScore) {
        setResultClass = winClassName;
        setWinner = true;
      }
      setScore = set.HomeScore;
      tieBreakScore = set.HomeTieBreakScore;
    } else {
      if (set.HomeScore < set.AwayScore) {
        setResultClass = winClassName;
        setWinner = true;
      }
      setScore = set.AwayScore;
      tieBreakScore = set.AwayTieBreakScore;
    }

    if (isLiveMatch && index === sets.length - 1) {
      liveClass = matchCardLiveClassName;
      setResultClass = '';
    }

    if (liveClass) {
      setSpan.classList.add(liveClass);
    }
    if (setResultClass) {
      setSpan.classList.add(setResultClass);
    }

    // set score data
    setSpan.appendChild(document.createTextNode(setScore));

    // tieBreak score data
    const supEl = this.createHtmlElement('SUP');
    supEl.appendChild(document.createTextNode(tieBreakScore));
    if (tieBreakScore && tieBreakScore > 0 && !setWinner) {
      setSpan.appendChild(supEl);
    }
  }

  createHtmlElement(elType, elClasses = [], elAttributes = []) {
    const newEl = document.createElement(elType);

    elClasses.forEach((elClass) => {
      newEl.classList.add(elClass);
    });

    elAttributes.forEach((elAttribute) => {
      newEl.setAttribute(elAttribute, '');
    });

    return newEl;
  }

  isLiveMatch(status) {
    return this.getLiveStatus(status.toLowerCase());
  }

  setPlayerScore(element, data, playerHook, scoreHook) {
    let scoreContainer = $(element).find(playerHook).find(scoreHook);
    if (!scoreContainer || scoreContainer.length === 0) {
      scoreContainer = this.createHtmlElement('DIV', ['tc-match__stats'], ['js-match-card-score']);
      scoreContainer.appendChild(data);

      const scoreWrapper = $(element).find(playerHook).find(matchCardDetailScoreContainerHook);
      scoreWrapper.append(scoreContainer);
    } else {
      scoreContainer.html(data);
    }
  }

  addSetPlayerScore(score, element, playerHook, scoreHook) {
    if (!isNil(score)) {
      this.setPlayerScore(element, score, playerHook, scoreHook);
    }
  }

  setLiveUpcomingMatches() {
    const matches = [...this.items].filter((matchWrapper) => {
      const matchCard = matchWrapper.querySelector(this.cardMatchClass);
      return matchCard.attributes && matchCard.attributes[matchCardMatchIdAttr];
    });
    this.liveUpcomingMatches = matches;
    this.remainingLiveUpcomingMatches = matches;
  }

  setLiveMatchesAndCountDownTime() {
    const now = moment();

    each(this.liveUpcomingMatches, (matchWrapper, index) => {
      const match = matchWrapper.querySelector(this.cardMatchClass);

      const startTime = moment(match.attributes[matchCardLiveStartTimeAttr].value);
      const timeDiff = startTime.diff(now) - this.countDownTime;
      if (index === 0 || timeDiff < this.lowestCountDownTime) {
        this.lowestCountDownTime = timeDiff;
      }

      const status = $(match).attr(matchCardMatchStatusAttr).toLowerCase();
      if (status === matchCardLiveStatus) {
        this.existLiveMatch = true;
      }
    });
  }

  toLocalTime() {
    this.localItems = x(localTimeHook);
    this.localTime.initItems(this.localItems);
  }

  handleEvents() {
    if (this.items.length > 0) {
      this.initPolling();
    }
  }

  init() {
    if (this.items) {
      this.handleEvents();

      if (!window.isSetClearIntervalDataLoadEventListener) {
        window.addEventListener(dataLoadStartEvent, () => {
          const interval_id = window.setInterval(() => '', 9999);
          for (let i = 1; i < interval_id; i++) window.clearInterval(i);
          window.isSetClearIntervalDataLoadEventListener = true;
        });
      }
    }
  }
}
